import InvalidEnum from '../invalid_enum'

class InvalidRejectReason extends InvalidEnum {
  static REJECT_REASON = {
    SERVER_ERROR: 'server-error',
    ERROR_READING: 'error-reading',
    UPLOAD_ERROR: 'error-uploading',
  }

  constructor(value) {
    super(
      value,
      'reject_reason',
      Object.values(InvalidRejectReason.REJECT_REASON)
    )
  }
}

export default InvalidRejectReason
